import React from 'react';
import Reveal from './Reveal';
import SectionHead from './SectionHead';
import { team } from '../data/site';

// Renders only once team members are added in src/data/site.js.
const Team = () => {
  if (team.length === 0) return null;

  return (
    <section className="section">
      <div className="container">
        <SectionHead eyebrow="Our team" title="The people behind the work" />
        <div className="team-grid">
          {team.map((member, index) => (
            <Reveal key={member.name} className="team-card" delay={index * 0.06}>
              <img src={member.photo} alt={member.name} loading="lazy" />
              <h3>{member.name}</h3>
              <span>{member.role}</span>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;
